export default __webpack_public_path__ + "static/media/greenTheme-girl.3db55e7f.svg";